import { z } from "zod"

// Enums
export const alignSchema = z.enum(["center", "end", "start"])
export type Align = z.infer<typeof alignSchema>

export const fontWeightSchema = z.enum([
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
])
export type FontWeight = z.infer<typeof fontWeightSchema>

export const flexAlignSchema = z.enum(["flex-start", "flex-end", "center"])
export type FlexAlign = z.infer<typeof flexAlignSchema>

export const justifySchema = z.enum(["flex-start", "flex-end", "center"])
export type Justify = z.infer<typeof justifySchema>

export const TextTransformSchema = z.enum([
  "none",
  "capitalize",
  "uppercase",
  "lowercase",
])
export type TextTransform = z.infer<typeof TextTransformSchema>

export const TextAlignEnum = z.enum(["left", "right", "center"])
export type TextAlign = z.infer<typeof TextAlignEnum>

export const FontFamilySchema = z.string().min(1).max(255)
export type FontFamily = z.infer<typeof FontFamilySchema>

// Lengths
const cssLengthRegex = /^(0|-?\d+(\.\d+)?(px|em|rem|%|vh|vw|vmin|vmax))$/

export const cssLengthSchema = z.string().regex(cssLengthRegex, {
  message: "Invalid CSS length format (e.g., 0, 10px, 1.5em, -100%)",
})

export type CSSLength = z.infer<typeof cssLengthSchema>

// Colours
export const cssColorRegex = new RegExp(
  [
    "^#(?:[a-fA-F0-9]{3}|[a-fA-F0-9]{6})$", // Hex (#fff or #ffffff)
    "^rgb\\((\\s*\\d+\\s*,){2}\\s*\\d+\\s*\\)$", // rgb(255, 0, 0)
    "^rgba\\((\\s*\\d+\\s*,){3}\\s*(0|1|0?\\.\\d+)\\s*\\)$", // rgba(255, 0, 0, 0.5)
    "^hsl\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%\\s*\\)$", // hsl(360, 100%, 50%)
    "^hsla\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%\\s*,\\s*(0|1|0?\\.\\d+)\\s*\\)$", // hsla(360, 100%, 50%, 0.5)
    "^[a-zA-Z]+$", // Named colors (e.g., red, blue)
  ].join("|"),
  "i"
)
export const CSSColorSchema = z.string().regex(cssColorRegex, {
  message: "Invalid CSS color format",
})
export type CSSColor = z.infer<typeof CSSColorSchema>

export const cssTextDecorationSchema = z.enum([
  "none",
  "underline",
  "overline",
  "line-through",
])
export type CSSTextDecoration = z.infer<typeof cssTextDecorationSchema>
